import { createHttpInstance } from '~/common/utils/http';

const httpInstance = createHttpInstance('telli', { path: '/tudo/v2' });

export default httpInstance;
